const MESSAGE_DRAFT_PREFIX = "unjabbed-message-draft";

const getStorage = (): Storage | undefined => {
	try {
		return window.sessionStorage;
	} catch {
		return undefined;
	}
};

export const getMessageDraftKey = (userId: string, chatUserId: string) => {
	if (!userId || !chatUserId) return "";
	return `${MESSAGE_DRAFT_PREFIX}:${userId}:${chatUserId}`;
};

export const loadMessageDraft = (key: string) => {
	if (!key) return "";
	try {
		return getStorage()?.getItem(key) || "";
	} catch {
		return "";
	}
};

export const saveMessageDraft = (key: string, value: string) => {
	if (!key) return;
	try {
		const storage = getStorage();
		if (!storage) return;
		if (value) {
			storage.setItem(key, value);
		} else {
			storage.removeItem(key);
		}
	} catch {
		// A browser may block storage. Messaging must still keep working normally.
	}
};

export const clearMessageDraft = (key: string) => {
	if (!key) return;
	try {
		getStorage()?.removeItem(key);
	} catch {
		// A browser may block storage. The sent message still remains successful.
	}
};
